import React, { useState } from 'react';
import styled from 'styled-components';
import { Config } from './types';
import Notifications from './Notifications';
import { IconBellFilled } from '@tabler/icons-react';

const Container = styled.div<{
  width: number;
  height: number;
}>`
  display: flex;
  justify-content: center;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  align-items: center;
  position: relative;
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Button = styled.div<{
  paddingData: { top: number; bottom: number; left: number; right: number };
  borderData: { thickness: number; radius: number };
  width: number;
  height: number;
  lineColor: string;
  font: string;
  fontSize: number;
  bold: boolean;
  italic: boolean;
  underline: boolean;
  strikeThrough: boolean;
  backgroundData: any;
  textColor: string;
  characterSpacing: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ borderData }) => borderData.radius}px;
  border: ${({ borderData, lineColor }) =>
    `${borderData.thickness}px solid ${lineColor}`};
  padding: ${({ paddingData }) =>
    `${paddingData.top}px ${paddingData.right}px ${paddingData.bottom}px ${paddingData.left}px`};
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background-color: ${p =>
    p.backgroundData?.color !== '' ? p.backgroundData?.color : ''};
  font-family: ${({ font }) => font};
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
  text-decoration: ${({ underline, strikeThrough }) =>
    `${underline ? 'underline' : ''} ${strikeThrough ? 'line-through' : ''}`};
  cursor: pointer;
  color: ${({ textColor }) => textColor};
  letter-spacing: ${({ characterSpacing }) => characterSpacing}px;
`;

const Arrow = styled.span<{ isOpen: boolean }>`
  margin-left: 8px;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
`;

const NotificationWidget: React.FC<WidgetRenderProps<Config>> = (
  props: WidgetRenderProps<Config>
) => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    paddingData,
    borderData,
    width,
    height,
    lineColor,
    font,
    fontSize,
    bold,
    italic,
    underline,
    strikeThrough,
    backgroundData,
    characterSpacing,
    textColor,
  } = props.widgetState.config;

  return (
    <Wrapper>
      <Container height={height} width={width}>
        <Button
          paddingData={paddingData}
          borderData={borderData}
          width={width}
          height={height}
          lineColor={lineColor}
          font={font}
          fontSize={fontSize}
          bold={bold}
          italic={italic}
          underline={underline}
          strikeThrough={strikeThrough}
          backgroundData={backgroundData}
          characterSpacing={characterSpacing}
          textColor={textColor}
          onClick={() => setIsOpen(!isOpen)}
        >
          <IconBellFilled
            width={fontSize}
            height={fontSize}
            style={{ marginRight: '8px' }}
          />
          Notifications
          <Arrow isOpen={isOpen}>▼</Arrow>
        </Button>
      </Container>
      {isOpen && (
        <Notifications
          color={textColor}
          fontFamily={font}
          backgroundColor={backgroundData?.color || 'white'}
          height={height}
        />
      )}
    </Wrapper>
  );
};

export default NotificationWidget;
